export const NB_PROMO_OFFERS_SELECTION_DESKTOP = 'newbuilding_carousel_promo_page_desktop';
export const NB_PROMO_OFFERS_SELECTION_MOBILE = 'newbuilding_carousel_promo_page_mobile';

export const EXPERIMENTS = [NB_PROMO_OFFERS_SELECTION_DESKTOP, NB_PROMO_OFFERS_SELECTION_MOBILE];
